import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  players,
  playersForm,
  decks,
  decksForm,
  deckTypes,
  deckTypesForm,
  days,
  daysForm,
  rounds,
  roundsForm,
  games,
  gamesForm,
  deckPlayeds,
  deckPlayedsForm,
  placards,
  placardsForm,
  uploadeddecks,
  uploadeddecksForm,
  specialdays,
  specialdaysForm,
  forfundays,
  forfundaysForm,
  seasons,
  seasonsForm,
} from "./Reducers";

export default combineReducers({
  seasons,
  seasonsForm,
  forfundays,
  forfundaysForm,
  specialdays,
  specialdaysForm,
  uploadeddecks,
  uploadeddecksForm,
  placards,
  placardsForm,
  deckPlayeds,
  deckPlayedsForm,
  games,
  gamesForm,
  rounds,
  roundsForm,
  days,
  daysForm,
  deckTypes,
  deckTypesForm,
  decks,
  decksForm,
  players,
  playersForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
});
